// const apiUrl = "http://172.208.33.94:3001/api"; //Development
// const apiUrl = "https://stagingcallback.kipinn.com/api"; //Development
// const cashfreeMode = "sandbox"; //Development
const apiUrl = "https://apis.kipinn.com/api"; //Production
const cashfreeMode = "production"; //Production

const Config = {
  ApiUrl: apiUrl,
  CashfreeMode: cashfreeMode,
  DUES_TYPES: {
    RENT: 1,
    SECURITY: 2,
    MAINTENANCE: 3,
    ELECTRICITY: 4,
    REGISTRATION: 5,
    TECH_CHARGES: 6,
    OTHER: 7,
    AGREEMENT_CHARGE: 8,
    FOOD: 9,
    FINE: 10,
    SETTLEMENT: 11,
    WIFI_CHARGES: 12,
    GAS_CHARGES: 13,
    MAID_CHARGES: 14,
    DAMAGE_CHARGE: 15,
    KEY_LOSS_CHARGES: 16,
    LAUNDRY_BILL: 17,
    MOVE_OUT_CHARGES: 19,
    GUEST_CHARGES: 20
  },
  Verification_Enabled: {
    AadharNumber: 1,
    AadharPhoto: 0,
  },
  RENT_AGREEMENT_ENABLED: {
    Disabled: 1,
    Enabled: 0,
  },
  Verification_Type: {
    Aadhar: 1,
  },
  KYC_STATUS: {
    PENDING: 1,
    ID_UPLOADED: 2,
    PERSONAL_INFO: 3,
    SELFI_UPLOADED: 4,
    RENT_AGREEMENT_DONE: 5,
    POLICE_VERIFICATION_DONE: 6,
  },
  TRANSACTION_STATUS: {
    PENDING: 1,
    SUCCESS: 2,
    FAILED: 3,
  },
  TRANSACTION_MODES: {
    OFFLINE: 1,
    UPI: 2,
    NET_BANKING: 3,
    CARD: 4,
  },
  GST_ENABLED: {
    YES: 1,
    NO: 0,
  },
  PAYMENT_GATEWAY: {
    PAYU: 1,
    CASHFREE: 2,
    EASEBUZZ: 3,
  },
  STAFF_ROLES: {
    CLIENT: 0,
    ADMIN: 1,
    WARDEN: 2,
    ELECTRICIAN: 3,
    PLUMBER: 4,
    LAUNDRY: 5,
    CARPENTER: 6,
    PARTNER: 7,
    COOK: 8,
    HOUSEKEEPING: 9,
    SALESPERSON: 10,
    SECURITYGUARD: 11,
    FINANCEADMIN: 12,
    BACK_OFFICE: 13,
    HELPDESK: 14,
    BROKER: 15,
    AC_TECH: 16,
    PURIFIER_TECH: 17,
    PAINTER: 18
  },
  USER_TYPE: {
    CLIENT: 1,
    TENANT: 2,
    STAFF: 3,
    VENDOR: 4,
    LANDLORD: 5,
  },
};
export const staff_roles = [
  { label: "Admin", value: Config.STAFF_ROLES.ADMIN },
  { label: "Partner", value: Config.STAFF_ROLES.PARTNER },
  {
    label: "Warden",
    value: Config.STAFF_ROLES.WARDEN,
  },
  { label: "Sales Person", value: Config.STAFF_ROLES.SALESPERSON },
  { label: "Plumber", value: Config.STAFF_ROLES.PLUMBER },
  { label: "Electrician", value: Config.STAFF_ROLES.ELECTRICIAN },
  { label: "Laundry", value: Config.STAFF_ROLES.LAUNDRY },
  { label: "Carpenter", value: Config.STAFF_ROLES.CARPENTER },
  { label: "Cook", value: Config.STAFF_ROLES.COOK },
  { label: "House Keeping", value: Config.STAFF_ROLES.HOUSEKEEPING },
  { label: "Security Guard", value: Config.STAFF_ROLES.SECURITYGUARD },
  { label: "Finance Admin", value: Config.STAFF_ROLES.FINANCEADMIN },
  { label: "Back Office", value: Config.STAFF_ROLES.BACK_OFFICE },
  { label: "Help Desk", value: Config.STAFF_ROLES.HELPDESK },
  { label: 'Broker', value: Config.STAFF_ROLES.BROKER },
  { label: 'AC Tech', value: Config.STAFF_ROLES.AC_TECH },
  { label: 'Purifier Tech', value: Config.STAFF_ROLES.PURIFIER_TECH },
  { label: 'Painter', value: Config.STAFF_ROLES.PAINTER },
];


export default Config;
